<script>
  import Tailwind from "../Tailwind.svelte";
  import Departures from "./Departures.svelte";
  import Message from "../Message.svelte";
  import Annoucements from "../Annoucements.svelte";

  import { parseSystemUrl } from "../environments";

  let error = undefined;
  let stops = undefined;
  let firstStop = undefined;
  let groupId = undefined;
  let limit = undefined;
  let type = undefined;
  let systemUrl = undefined;

  try {
    const hostname = window.location.hostname
    systemUrl = parseSystemUrl(hostname)

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    let stopString = urlParams.get("stops");
    stops = stopString.split(",");
    firstStop = stops[0];
    limit = urlParams.get("limit");
    limit = isNaN(parseInt(limit)) ? 10 : parseInt(limit);
    type = (urlParams.get("type") === 'departures' || urlParams.get("type") === 'arrivals') ? urlParams.get("type") : 'departures';
  } catch (e) {
    console.log(e);
  }
</script>
<Tailwind/>
  <div class="text-white h-screen w-screen overflow-hidden font-3">
    <div class="grid grid-cols-frame grid-rows-frame h-full w-full">
      <div class="row-start-1 row-end-2 col-start-1 col-end-12 overflow-hidden">
        {#if stops && !error}
          <div class="bg-{type}-0 flex flex-row h-full w-full space-x-2 overflow-hidden">
            {#each stops as id}
              <Departures {id} {limit} {type} {systemUrl}/>
            {/each}
          </div>
        {:else}
          <Message
            title="Iremos ser breves..."
            text="Estamos com alguns problemas a mostrar a informação"
          />
        {/if}
      </div>
      <div class="row-start-2 row-end-4 col-span-full py-5 h-20 flex justify-between items-center header-bg-{type}">
        <Annoucements {firstStop} {systemUrl} {groupId}/>
      </div>
      <div class="w-48 h-20 header-bg-{type}">
        <img class="mr-4 mt-1" alt="Logo Fundo de Transportes" src="img/FSPT_logo_cor_01.png">
      </div>
    </div>
  </div>
